import React from "react";
import { BsArrowRight } from "react-icons/bs";
import baner from "../../assets/images/baner4.png";
import "./BanerSection.scss";

const BanerSection = ({ linkopingHome }) => {
	const scrollToBooking = () => {
		const elem = document.getElementById("booking");
		elem.scrollIntoView({ behavior: "smooth", block: "end" });
	};

	return (
		<div className="BanerSection">
			<img src={baner} alt="Baner" />
			<div className="baner-content">
				<h1>{linkopingHome ? `Skaffa städhjälp i Linköping` : `Dags för en enklare vardag?`}</h1>
				<p>
					{linkopingHome ? `Räkna enkelt ut ditt pris och boka högsta kvalitet av städning enkelt online.` : `Få en prisuppskattning och beställ städning av högsta kvalitet enkelt
					online.` }
				</p>
				<button onClick={scrollToBooking}>
					Beräkna ditt pris <BsArrowRight />{" "}
				</button>
			</div>
		</div>
	);
};

export default BanerSection;
